// Moved from `src/hooks/query/useQueryClinicalTasks.ts` (now a delegate) with
// the D2 family (ARCFE-945). Severed per the ARCFE-921 ratified mechanism: the
// legacy toast fired from inside the `queryFn` catch — on every failed attempt,
// not per mount — so the `onFetchError` port fires at exactly that line and the
// delegate owns the user-visible effect with byte-identical copy.
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { logger } from '@heidi/runtime/logger';

import { GET_CLINICAL_TASKS } from '../../contracts/keys';
import type {
  ClinicalTasksQueryParams,
  GetClinicalTasksResponse,
} from '../../contracts/types';
import { getClinicalTasks } from '../api/clinical-tasks';

interface UseQueryClinicalTasksOptions {
  enabled?: boolean;
  /** App-reaction port: fired where the legacy toast fired (ARCFE-921). */
  onFetchError?: (error: unknown) => void;
}

export const useQueryClinicalTasks = (
  params?: ClinicalTasksQueryParams,
  options?: UseQueryClinicalTasksOptions
) => {
  return useQuery<GetClinicalTasksResponse, Error>({
    queryKey: [GET_CLINICAL_TASKS, params],
    enabled: options?.enabled,
    queryFn: async () => {
      try {
        const { data } = await getClinicalTasks(params);
        return data;
      } catch (error) {
        logger.error(
          'Error fetching tasks:',
          error instanceof AxiosError ? error.response?.data : error
        );
        options?.onFetchError?.(error);
        throw error;
      }
    },
    refetchOnMount: 'always',
  });
};
